import { render } from "./table-snippet.vue?vue&type=template&id=d8f1ba62"
import script from "./table-snippet.vue?vue&type=script&lang=js"
export * from "./table-snippet.vue?vue&type=script&lang=js"

import "./table-snippet.vue?vue&type=style&index=0&id=d8f1ba62&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__